var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessage2 = function SvgMessage2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 1.351v17H7.12l-.15.171-5.484 6.264L1.255 1.35H40.25Z",
    stroke: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.8,
    d: "M6.25 6.771h30M6.25 9.771h30M6.25 12.771h30"
  })));
};
export default SvgMessage2;